import React from 'react';

import './FilterTextInput.scss';

interface IFilterTextInput {
  value: string;
  name: string;
  config?: Object;
  callback: Function;
  save: Function;
}

export const FilterTextInput: React.FC<IFilterTextInput> = ({
  value,
  name,
  config,
  callback,
  save,
}) => {
  const clearValue = () => {
    callback(name, '');
  };

  const handleOnChange = (value: string) => {
    callback(name, value.trim());
  };

  return (
    <>
      <div className='filter-text-input'>
        <input
          type='text'
          {...config}
          value={value}
          title={value}
          onKeyPress={(event) => (event.key === 'Enter' ? save() : null)}
          onChange={(e) => handleOnChange(e.target.value)}
        ></input>

        <span
          className={value !== '' ? 'clear-icon show' : 'clear-icon hide'}
          onClick={() => clearValue()}
        >
          <i className='fa fa-times' onClick={() => clearValue()} />
        </span>
      </div>
    </>
  );
};
